/* Royale Merchant - auto free gift: 1 Coral Chain on orders $100+ (one per cart) */
(function(){
  /* ============================================================
   * PROMO CONFIG: 4th of July free gift
   * - Set ENABLED to false to turn the promo off immediately.
   * - Auto-expires at END_DATE: once Date.now() passes it, this
   *   script does NOTHING (no cart watching, no fetch/XHR patching).
   * ============================================================ */
  var ENABLED = true;
  var END_DATE = '2026-07-07T00:00:00-04:00'; // promo runs through July 6, 2026 (EDT)
  var THRESHOLD = 10000;                        // $100.00 in cents of non-gift items required to unlock the gift

  if(!ENABLED) return;
  if(Date.now() >= new Date(END_DATE).getTime()) return;
  if(window.__rmFreeGiftInit) return; window.__rmFreeGiftInit = 1; // guard: never run twice on one page

  var GIFT_VID = 51305295315226;          // Coral Chain variant id
  var GIFT_HANDLE = 'coral-chain-1';
  var GIFT_LABEL = 'Free 4th of July Gift';
  var selfBusy = false;
  var timer = null;
  var giftAddFailed = false; // set when /cart/add.js fails for the gift; stops retries for the rest of the page session

  function isGift(it){ return it && (it.variant_id === GIFT_VID || it.handle === GIFT_HANDLE); }

  function getCart(){ return fetch('/cart.js', { headers: { 'Accept':'application/json' } }).then(function(r){ return r.json(); }); }

  function mutate(url, body){
    selfBusy = true;
    return fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); })
      .then(function(res){ return res; })
      .catch(function(){ return null; })
      .then(function(res){ setTimeout(function(){ selfBusy = false; }, 60); return res; });
  }

  function addGift(){
    selfBusy = true;
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: [ { id: GIFT_VID, quantity: 1, properties: { 'Gift': GIFT_LABEL } } ] }) })
      .then(function(r){
        if(!r.ok){ giftAddFailed = true; }
        return r.json().catch(function(){ return null; });
      })
      .catch(function(){ giftAddFailed = true; return null; })
      .then(function(res){ setTimeout(function(){ selfBusy = false; }, 60); return res; });
  }

  function reconcile(){
    return getCart().then(function(cart){
      var items = (cart && cart.items) || [];
      var giftQty = 0, qualifying = 0;
      items.forEach(function(it){
        if(isGift(it)){ giftQty += it.quantity; }
        else { qualifying += (it.original_line_price || 0); }
      });
      var QUALIFIES = qualifying >= THRESHOLD;
      if(QUALIFIES && giftQty === 0){
        if(giftAddFailed){ return false; }
        return addGift().then(function(){ return !giftAddFailed; });
      }
      if(QUALIFIES && giftQty > 1){
        return mutate('/cart/change.js', { id: GIFT_VID, quantity: 1 }).then(function(){ return true; });
      }
      if(!QUALIFIES && giftQty > 0){
        return mutate('/cart/change.js', { id: GIFT_VID, quantity: 0 }).then(function(){ return true; });
      }
      return false;
    }).catch(function(){ return false; });
  }

  function refreshUI(){
    return getCart().then(function(cart){
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('cart:build')); } catch(e){}
      try { if(window.theme && theme.cart && typeof theme.cart.updateView === 'function'){ theme.cart.updateView(); } } catch(e){}
      return cart;
    });
  }

  function run(){
    if(selfBusy) return;
    reconcile().then(function(changed){ if(changed){ refreshUI(); } });
  }

  function schedule(){ if(selfBusy) return; clearTimeout(timer); timer = setTimeout(run, 140); }

  // Initial pass
  if(document.readyState !== 'loading'){ run(); } else { document.addEventListener('DOMContentLoaded', run); }

  // React to any cart mutation (fetch)
  var origFetch = window.fetch;
  window.fetch = function(){
    var a0 = arguments[0];
    var url = (typeof a0 === 'string') ? a0 : (a0 && a0.url) || '';
    var p = origFetch.apply(this, arguments);
    if(!selfBusy && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)){
      p.then(function(){ schedule(); }).catch(function(){});
    }
    return p;
  };

  // React to any cart mutation (XHR)
  var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(m, u){ this.__rmUrl = u; return oOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function(){
    var x = this;
    if(!selfBusy && /\/cart\/(add|change|update|clear)(\.js)?/.test(x.__rmUrl || '')){
      x.addEventListener('loadend', function(){ schedule(); });
    }
    return oSend.apply(this, arguments);
  };
})();
